import React, { useEffect } from 'react'
import { toast } from 'react-toastify';
import useCustomerProfile from './useCustomerProfile'
import { useAuth } from '../../context/AuthContext';
import { formatDate } from '../../utils/dateUtils';

const Blacklist = () => {

  const {profiles, getBlacklistProfile, removeProfileFromBlacklist} = useCustomerProfile()
  const { authState } = useAuth();
  const isSuperuser = authState?.user?.role === 'superuser';

  const isToday = (date) => {
    const today = new Date();
    const givenDate = new Date(date);
    return (
      today.getDate() === givenDate.getDate() &&
      today.getMonth() === givenDate.getMonth() &&
      today.getFullYear() === givenDate.getFullYear()
    );
  };

  const handleRemove = async (customerId, contact) => {
    if (!window.confirm(`ยืนยันลบ ${contact} ออกจาก Blacklist ?`)) return;
    const success = await removeProfileFromBlacklist(customerId);
    if (success) {
      toast.success(`ลบ ${contact} ออกจาก Blacklist แล้ว`);
      getBlacklistProfile();
    } else {
      toast.error('ลบออกจาก Blacklist ไม่สำเร็จ');
    }
  };

  useEffect(() => {
    getBlacklistProfile()
  },[])

  return (
    <div>
      <h2 className='text-5xl'>รายชื่อ Blacklist</h2>
      <table className="min-w-full divide-y divide-gray-300">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-lg font-semibold text-gray-900 sm:pl-6">
              No
            </th>
            <th scope="col" className="px-3 py-3.5 text-left text-lg font-semibold text-gray-900">
              Contact
            </th>
            <th scope="col" className="px-3 py-3.5 text-left text-lg font-semibold text-gray-900">
              วันที่โดน Blacklist
            </th>
            <th scope="col" className="px-3 py-3.5 text-left text-lg font-semibold text-gray-900">
              Type
            </th>
            {isSuperuser && (
              <th scope="col" className="px-3 py-3.5 text-left text-lg font-semibold text-gray-900">
                Action
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {profiles && profiles.map((profile, index) => {
              const contact = profile.CustomerProfile.contact
              const blacklistDate = profile.blacklistDate
              const isBlacklistToday = isToday(blacklistDate);
              return <tr key={contact} className={isBlacklistToday ? 'bg-yellow-200' : ''}>
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-lg font-medium text-gray-900 sm:pl-6">
                  {index + 1}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-lg text-gray-500">{contact}</td>
                <td className="whitespace-nowrap px-3 py-4 text-lg text-gray-500">{formatDate(blacklistDate)}</td>
                <td className="whitespace-nowrap px-3 py-4 text-lg">
                  {profile.source === 'manual' ? (
                    <span className="inline-flex items-center rounded-full bg-red-100 px-2 py-0.5 text-sm font-semibold text-red-800">Manual</span>
                  ) : (
                    <span className="text-gray-500">Auto</span>
                  )}
                </td>
                {isSuperuser && (
                  <td className="whitespace-nowrap px-3 py-4 text-lg">
                    <button
                      className="rounded-md bg-red-600 px-3 py-1 text-sm font-semibold text-white hover:bg-red-500"
                      onClick={() => handleRemove(profile.customerId, contact)}
                    >
                      ลบออกจาก Blacklist
                    </button>
                  </td>
                )}
              </tr>
            })}
        </tbody>
      </table>
    </div>
  )
}

export default Blacklist
